import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluck',
  standalone: true
})
export class PluckPipe implements PipeTransform {
  transform<T extends object, K extends keyof T>(array: T[], key: K | string): T[K][] {
    return array.map(value => value[key as never]);
  }
}
